module.exports = import("https://esm.sh/three");;